import { words } from './globalState';
import {
  isSessionValid,
} from './keysAndSigning';
import { syncHttpRequest, syncHttpRequest2, devLog } from './utils';

// HANDLE CLICK SAVE NOTE
async function handleClickSaveNote(state, dispatch, mode, addressMain, noteNo, { keyPairs, note } = {}) {
  let request = {};
  let messages = {};
  let certification = {};
  const now = Date.now();

  if (note !== undefined && note !== null) {
    noteNo = note.noteNo;
  }

  // state固定
  const stateFixed = {
    note: note !== undefined && note !== null ? note : state.notes[addressMain][noteNo],
    sessionId: state.session[addressMain]?.sessionId,
    expirationOfSession: state.session[addressMain]?.expirationOfSession,
    signatureVersion: state.config.clientParameters.signatureVersion.saveNote,
    addressCheck: state.addressCheck,
  };

  // 下書きがない状態で保存しようとしているので、エラー返却。

  if (stateFixed.note.draft === undefined || stateFixed.note.draft === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseLoginInAdvance[state.language] });
    throw new Error('draft is undefined');
  }

  // メインアドレスのセッションが存在しない、または、期限が切れていれば、署名する。

  if ( stateFixed.sessionId !== undefined && stateFixed.expirationOfSession >= now + state.marginOfSessionTime ) { // セッションが有効
    certification = {
      address: addressMain,
      sessionId: stateFixed.sessionId,
    };
  }
  else {

    // -- Mpurseのアドレス取得
    const result = await window.mpurse.getAddress()
    .then( async (result) => {
      const addressActual = result;
      const clientTimeMona = now;

      if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
        if (addressActual !== addressMain) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          // 続行
        }
      }
      else { // off
        // 続行
      }

      const message = `I will save the note of ${addressMain}. (epoch time: ${clientTimeMona}, signature version: ${stateFixed.signatureVersion})`;
      devLog('message', message);

      let signatureMona;

      try {
        signatureMona = await window.mpurse.signMessage(message).then( result => result );

        certification = {
          address: addressMain,
          addressActual: addressActual,
          clientTime: clientTimeMona,
          signatureVersion: stateFixed.signatureVersion,
          signature: signatureMona,
        };
      }
      catch (err) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
        return 'rejected';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      throw new Error('rejected to get address');
    }
  }

  // GO！

  const formData = new FormData();

  const requestJson = JSON.stringify({
    body: {
      certification: certification,
      mode: mode,
      note: stateFixed.note,
    }
  });

  devLog('upsert note; request json', JSON.stringify(requestJson, null, 2));
  formData.append('json', requestJson);

  for (const publicationType of Object.keys(stateFixed.note)) {
    if (stateFixed.note[publicationType].images !== undefined) {
      for (const resourceId of Object.keys(stateFixed.note[publicationType].images)) {
        if (stateFixed.note[publicationType].images[resourceId].status === 'created' || stateFixed.note[publicationType].images[resourceId].status === 'updated') {
          const fieldname = 'image';
          const data = stateFixed.note[publicationType].images[resourceId].data;
          const filename = addressMain + '_' + noteNo + '_' + publicationType + '_image_' + resourceId;
          formData.append(fieldname, data, filename);
        }
      }
    }
  }

  request.body = formData;
  request.headers = {
    'Accept': 'application/json',
  };
  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/upsert_note';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "success": words.success[state.language],
  };

  // const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  devLog('upsert note; request', JSON.stringify(request, null, 2));

  const responseRaw = await syncHttpRequest(request);
  // const responseRawObj = JSON.parse(responseRaw);
  devLog('upsert note; response', JSON.stringify(responseRaw, null, 2));

  if (responseRaw.body.message === 'Request Too Long') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.theUploadSizeIsTooLargeYouMayBeAbleToResolveThisBySplittingTheUploadIntoMultipleSmallerParts[state.language] });
    throw new Error('Request Too Long');
  }
  else if (responseRaw.body.applicationMessage === undefined || responseRaw.body.body === undefined) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.internalServerError[state.language] });
    throw new Error('no body');
  }

  const response = responseRaw.body;

  // 通知

  dispatch({ type: 'setNotification', key: 'notification', value: (messages[response.applicationMessage] ? messages[response.applicationMessage] : response.applicationMessage) });  

  for (const address of Object.keys(response.body.addressInformation || {})) {
    // 署名した場合もろもろ更新
    if (response.body.addressInformation[address]['certificatedBy'] === 'signature') {

      // session更新
      dispatch({
        type: 'setStateMultiLayers',
        keys: ['session', address],
        value: {'sessionId': response.body.addressInformation[address].sessionId, 'expirationOfSession': response.body.addressInformation[address].expirationOfSession}
      });
    }
    else if (response.body.addressInformation[address]['certificatedBy'] === 'none') {
      dispatch({
        type: 'setStateMultiLayers',
        keys: ['session', address],
        value: { expirationOfSession: 0 }
      });
    }
  }

  if ( response.applicationMessage === 'success' ) {
    // itemPlacement情報更新
    dispatch({
      type: 'setStateMultiLayersNum',
      keys: ['items', addressMain, 'itemPlacement', 0, 'updateTime'],
      value: response.body.updateTimeItemPlacement,
    });

    //  noteの更新時間を更新
    dispatch({
      type: 'setStateMultiLayersNum',
      keys: ['notes', addressMain, noteNo, 'updateTime'],
      value: response.body.updateTime,
    });

    // 署名付きURLでCloudFrontにアップロードではなく、presignedPostでアップロード。

    const promises = [];

    for (const publicationType of Object.keys(stateFixed.note)) {
      if (stateFixed.note[publicationType].images !== undefined) {
        for (const resourceId of Object.keys(stateFixed.note[publicationType].images)) {
          if (stateFixed.note[publicationType].images[resourceId].status === 'createdDirectUpload' || stateFixed.note[publicationType].images[resourceId].status === 'updatedDirectUpload') {
            const form = new FormData();

            for (const [key, value] of Object.entries(response.body.presignedPost[publicationType][resourceId].fields)) {
              form.append(key, value);
            }

            form.append("file", stateFixed.note[publicationType].images[resourceId].data);

            promises.push(
              // fetch(response.body.signedUrls[publicationType][resourceId], {
              //   method : 'PUT',
              //   headers: {
              //     'Content-Type': stateFixed.note[publicationType].images[resourceId].contentType
              //   },
              //   body: stateFixed.note[publicationType].images[resourceId].data
              // })
              fetch(response.body.presignedPost[publicationType][resourceId].postUrl, {
                method: 'POST',
                body: form,
              })
              .then( res => {
                if (!res.ok) {
                  devLog('failed to upload image: ', JSON.stringify(res, null, 2));
                  dispatch({ type: 'setNotification', key: 'notification', value: words.failedToUploadImage[state.language] });
                }
              })
              .catch( err => {
                devLog('failed to upload image: ', JSON.stringify(err, null, 2));
                dispatch({ type: 'setNotification', key: 'notification', value: words.failedToUploadImage[state.language] });
              })
            );
          }
        }
      }
    }

    await Promise.all(promises);

    // -- ノート情報更新
    // galleryに戻ったときに、note情報がクリアされてしまうから、すべてのノートに関して、load statusを初期化する。
    // だから、このタイミングでリロードしない。
    // ただしpubulish, unpublishの場合は、そのまま、公開版に切り替えられる可能性もあるので、note情報をリロードする。
    // いやいや、popupDisplayの画像を保存した場合、並べ替えされると再レンダリングが走ってURLがrevokeされてしまうので、リロードしなければならない。

    dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'popupDisplay', addressMain], value: false });
    dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', addressMain], value: {} });

    getNote({
      dispatch,
      searchType: 'specificMyOwnNotes',
      addressesMain: [addressMain],
      noteNos: [noteNo],
      session: state.session,
      marginOfSessionTime: state.marginOfSessionTime,
      notes: state.notes,
    })
    .then( result => {
      const notes = result[addressMain].notes;

      const components = notes.map( note => {
        return ['components', 'popupDisplay'].map( componentContainer => {
          return getComponents({
            note,
            componentContainer,
            session: state.session,
            marginOfSessionTime: state.marginOfSessionTime,
          });
        }).flat();
      }).flat();

      getUserResource({
        dispatch,
        userResources: components,
        session: state.session,
        marginOfSessionTime: state.marginOfSessionTime,
      });
    })

    // -- ノート保存状態更新

    let maybeNotSaved = state.editNote.maybeNotSaved.addressMain;

    if (maybeNotSaved === undefined) {
      maybeNotSaved = {};
    }

    maybeNotSaved[noteNo] = false;

    dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
  }
  else {
    devLog('error', JSON.stringify(response));
    throw new Error('failed to update note');
  }

  return response;
}

// GET NOTE
async function getNote({ dispatch, searchType, addressesMain, noteNos, session, marginOfSessionTime, notes }) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = new Date();

  // state固定
  const stateFixed = {
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(session)) {
    // state固定
    stateFixed[address] = {
      sessionId: session[address].sessionId,
      expirationOfSession: session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now.getTime() + marginOfSessionTime) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  certifications = certifications.filter( certifications => addressesMain.includes(certifications.address) );


  if (searchType === 'specificNotes') {
    request.body = JSON.stringify({
      body: {
        searchType: searchType,
        addressesMain: addressesMain,
        noteNos: noteNos,
      }
    });
  }
  else if (searchType === 'specificMyOwnNotes') {
    request.body = JSON.stringify({
      body: {
        searchType: searchType,
        certifications : certifications,
        addressesMain: addressesMain,
        noteNos: noteNos,
      }
    });
  }
  else if (searchType === 'specificAdressesMain') {
    request.body = JSON.stringify({
      body: {
        searchType: searchType,
        addressesMain: addressesMain,
        // notes: notes,
      }
    });
  }
  else if (searchType === 'myOwnNotes') {
    request.body = JSON.stringify({
      body: {
        searchType: searchType,
        certifications : certifications,
        addressesMain: addressesMain,
      }
    });
  }

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_note';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, null, null, null, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    if (searchType === 'specificNotes') {
      for (const addressMain of Object.keys(response.body)) {
        const notes = response.body[addressMain]?.notes;

        if (notes !== undefined) {
          let notesObj;

          if (notes[addressMain] !== undefined) {
            notesObj = notes[addressMain];
          }
          else {
            notesObj = {};
          }

          for (const note of notes) {
            if (note.published !== undefined) {
              note.published.texts = {};
              note.published.images = {};
            }

            notesObj[note.noteNo] = note;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain], value: notesObj });
        }
      }
    }
    else if (searchType === 'specificMyOwnNotes') {
      for (const addressMain of Object.keys(response.body)) {
        const notes = response.body[addressMain]?.notes;

        if (notes !== undefined) {
          let notesObj;

          if (notes[addressMain] !== undefined) {
            notesObj = notes[addressMain];
          }
          else {
            notesObj = {};
          }

          for (const note of notes) {
            if (note.draft !== undefined) {
              note.draft.texts = {};
              note.draft.images = {};
            }

            if (note.published !== undefined) {
              note.published.texts = {};
              note.published.images = {};
            }

            notesObj[note.noteNo] = note;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain], value: notesObj });
        }
      }
    }
    else if (searchType === 'specificAdressesMain') {
      for (const addressMain of Object.keys(response.body)) {
        const notes = response.body[addressMain]?.notes;

        if (notes !== undefined) {
          let notesObj = {};

          for (const note of notes) {
            if (note.published !== undefined) {
              note.published.texts = {};
              note.published.images = {};
            }

            notesObj[note.noteNo] = note;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain], value: notesObj });
        }
      }
    }
    else if (searchType === 'myOwnNotes') {
      for (const addressMain of Object.keys(response.body)) {
        const notes = response.body[addressMain]?.notes;

        if (notes !== undefined) {
          let notesObj = {};

          for (const note of notes) {
            if (note.draft !== undefined) {
              note.draft.texts = {};
              note.draft.images = {};
            }

            if (note.published !== undefined) {
              note.published.texts = {};
              note.published.images = {};
            }

            notesObj[note.noteNo] = note;
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain], value: notesObj });
        }
      }
    }

    return response.body;
  }
  else {
    throw new Error('failed to get note');
  }
}

// GET USER RESOURCE
async function getUserResource({ dispatch, userResources, session, marginOfSessionTime }) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = new Date();

  // state固定
  const stateFixed = {
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(session)) {
    // state固定
    stateFixed[address] = {
      sessionId: session[address].sessionId,
      expirationOfSession: session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now.getTime() + marginOfSessionTime) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  // userResources取得に必要なcertificationsに絞り込む。

  const addressesMain = userResources.map( userResource => userResource.addressMain );
  certifications = certifications.filter( certifications => addressesMain.includes(certifications.address) );

  request.body = JSON.stringify({
    body: {
      certifications : certifications,
      userResources: userResources,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_user_resource';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, null, null, null, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    for (const userResource of response.body.userResources) {
      if (userResource.status === 'succeeded') {
        if (userResource.resourceType === 'text') {
          const text = {
            content: userResource.content,
          };

          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', userResource.addressMain, userResource.noteNo, userResource.publicationType, 'texts', userResource.resourceId],
            value: text
          });
        }
        else if (userResource.resourceType === 'image') {
          const image = {
            url: userResource.url,
          };

          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', userResource.addressMain, userResource.noteNo, userResource.publicationType, 'images', userResource.resourceId],
            value: image
          });
        }
      }
      else {
      }
    }

    return response.body;
  }
  else {
    throw new Error('failed to get user resource');
  }
}

// GET NOTE AND USER RESOURCE
async function getNotesAndUserResources({ dispatch, addressMain, componentContainers, session, marginOfSessionTime, notes }) {
  let searchType;

  if (isSessionValid({ address: addressMain, session, marginOfSessionTime })) {
    searchType = 'myOwnNotes';
  }
  else {
    searchType = 'specificAdressesMain';
  }

  return getNote({
    dispatch,
    searchType,
    addressesMain: [addressMain],
    session,
    marginOfSessionTime,
    notes,
  })
  .then( result => {
    // -- ユーザーリソース取得

    const notes = result[addressMain].notes;

    const components = notes.map( note => {
      return componentContainers.map( componentContainer => {
        return getComponents({
          note,
          componentContainer,
          session,
          marginOfSessionTime,
        });
      }).flat();
    }).flat();

    getUserResource({
      dispatch,
      userResources: components,
      session,
      marginOfSessionTime,
    });
  });
}

// GET COMPONENTS
function getComponents({ note, componentContainer, session, marginOfSessionTime }) {
  let components;
  let componentsPublished = [];
  let componentsDraft = [];

  if (note.published !== undefined) {
    componentsPublished = note.published[componentContainer].map( component => {
      if (component.resourceType === 'text' || component.resourceType === 'image') {
        return {
          addressMain: note.addressMain,
          noteNo: note.noteNo,
          publicationType: 'published',
          resourceType: component.resourceType,
          resourceId: component.resourceId,
          suffix: component.suffix,
          timestamp: component.timestamp,
        };
      }
      else {
        throw new Error('resourceType is invalid');
      }
    });
  }

  if (isSessionValid({ address: note.addressMain, session, marginOfSessionTime }) && note.draft !== undefined) {
    componentsDraft = note.draft[componentContainer].map( component => {
      if (component.resourceType === 'text' || component.resourceType === 'image') {
        return {
          addressMain: note.addressMain,
          noteNo: note.noteNo,
          publicationType: 'draft',
          resourceType: component.resourceType,
          resourceId: component.resourceId,
          suffix: component.suffix,
          timestamp: component.timestamp,
        };
      }
      else {
        throw new Error('resourceType is invalid');
      }
    });
  }

  components = componentsPublished.concat(componentsDraft);

  return components;
}

export {
  handleClickSaveNote,
  getNote,
  getUserResource,
  getNotesAndUserResources,
  getComponents,
};
